export default "__VITE_ASSET__B_VXrbn5__"